import * as React from 'react'
import { SVGProps } from 'react'
const SvgPlayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg height={16} viewBox="0 0 16 16" width={16} {...props}>
    <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM6 12V4l6 4z" />
  </svg>
)
export default SvgPlayIcon
